import Conf from '../conf/auth.json';
import ConfApi from '../conf/back.json';
import { Buffer } from 'buffer';

let access_token = null;
let user_info = null;

let disabilitiesList = null;

let externalInfo = null;
let requests = null;

let benefits_dict = [];
let groups_types = [];

let isFinishInitToken = true;

const PERSISTENTS_STORAGE = {
  token: 'access_token',
  user_info: 'user_info',
  externalservice: 'externalservice',
  requests: 'requests',
  benefits_dict: 'benefits_dict',
  groups_types: 'groups_types'
};

const DICTIONARY = {
  benefits_dict: {val: benefits_dict, url: 'benefits'},
  groups_types: {val: groups_types, url: 'types_group'}
}

export const constr_uri = (endpoint)=>`/${ConfApi.version}/${endpoint}`;

const buildOAuthUrl = () => {
    const {
      oauthUrl,
      clientId,
      redirectUri,
      scope = 'openid profile email',
      responseType = 'code'
    } = Conf.oauthConfig;

    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: responseType,
      scope: scope,
      state: Math.random().toString(36).substring(2), // CSRF protection
      
      ...Conf.oauthConfig.additionalParams
    });

    return `${oauthUrl}?${params.toString()}`;
};


export const handleLogin = () => {
  const oauthUrl = buildOAuthUrl();
  window.location.href = oauthUrl;
};

export const setAuthToken = (token) => {
  
  if(token) access_token = token;
  
  
  if (access_token) {
    try {
      localStorage.setItem(PERSISTENTS_STORAGE.token, token);
    } catch (e) {
      console.error('Failed to save token to localStorage:', e);
      // Но access_token уже сохранен!
    }
  } else {
    try {
      localStorage.removeItem(PERSISTENTS_STORAGE.token);
    } catch (e) {
      console.error('Failed to remove token from localStorage:', e);
    }
  }

};

export const setUserInfo = (userInfo)=>{

  user_info = userInfo;

  if (userInfo) {
    localStorage.setItem(PERSISTENTS_STORAGE.user_info, JSON.stringify(userInfo));
  } else {
    localStorage.removeItem(PERSISTENTS_STORAGE.token);
  }
}

export const setUserRequests = (requests_)=>{

  requests = requests_;

  if (requests_) {
    localStorage.setItem(PERSISTENTS_STORAGE.requests, JSON.stringify(requests_));
  } else {
    localStorage.removeItem(PERSISTENTS_STORAGE.token);
  }
}

export const getBenefitsDictionary = async ()=> {
    return await getDictionary('benefits_dict');
}

export const getGroupsDictionary = async ()=> {
    const res = await getDictionary('groups_types');
    return res.filter(r=>!r.disabled);
}

const getDictionary = async (d) => {

  let { val, url } = DICTIONARY[d];

  if(val?.length > 0) return val;

  const storage = localStorage.getItem(PERSISTENTS_STORAGE[d]);

  const data = storage && JSON.parse(storage) || [];

  if(data?.length > 0) {
    val = data;
    return val;
  }

  const info_dict = await apiClient.get(url);

  if(!info_dict.data) return val;

  
  localStorage.setItem(PERSISTENTS_STORAGE[d], JSON.stringify(info_dict.data));
  
  val = info_dict.data;
  
  return val;

}


export const getUserRequests = () => {
  
  if(requests) return requests;
  
  const storage = localStorage.getItem(PERSISTENTS_STORAGE.requests);

  if(storage) return JSON.parse(storage);

  return null;

};

export const setExternalUserInfo = ( extInfo )=>{

  externalInfo = extInfo;

  if(extInfo){
    const obj = { url: extInfo.url, name: extInfo.name };

    localStorage.setItem(PERSISTENTS_STORAGE.externalservice, JSON.stringify(obj));
  } else {
    localStorage.removeItem(PERSISTENTS_STORAGE.externalservice);
  }
}

export const addToExternalUserInfoRequests = (requests) => {
  if(!requests || requests.length < 1 ) return;
  if(!externalInfo) externalInfo = {};
  externalInfo['requests'] = true;
  localStorage.setItem(PERSISTENTS_STORAGE.externalservice, JSON.stringify(externalInfo));
}


export const getExternalUserInfo = () => {

  if(externalInfo) return externalInfo;

  const storage = localStorage.getItem(PERSISTENTS_STORAGE.externalservice);

  if(storage) return JSON.parse(storage);

  return null;

}

export const getUserInfo = (role) => {

  if(!user_info) {
    const info = localStorage.getItem(PERSISTENTS_STORAGE.user_info);
    if(info) user_info = JSON.parse(info);
  }

  if(!user_info) return null;

  if(!role) return user_info;

  const getRole = (priv)=>{
    if(!priv) return null;
    const { role, role_main } = priv;
    if(role_main) return role_main;
    return role;
  }


  return getRole(user_info['privilegedUser']);
  
  if(!role && user_info) return user_info;

};

export const getDisabilitiesList = ()=>{
  return disabilitiesList;
}

export const setDisabilitiesList = async ()=>{

   if(disabilitiesList?.length > 0) return;

    const url = 'disabilities';

    const ret = await apiClient.get(url);

    if(!ret || !ret.data) return [];

    return disabilitiesList = ret.data;

}

export const initNewToken = async (code) => {

     if(!isFinishInitToken) return;

     isFinishInitToken = false;
    
      if (code) {
        try {
          
          const tokenResponse = await fetch(Conf.oauthConfig.tokenUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
              grant_type: 'authorization_code',
              code: code,
              client_id: Conf.oauthConfig.clientId,
              redirect_uri: Conf.oauthConfig.redirectUri,
              // client_secret если требуется
            }),
          });

          const tokenData = await tokenResponse.json();

          if(tokenData.error && tokenData.error.code && [1006, 1014].includes(tokenData.error.code) ) {

            //alert(`Модуль авторизації (зовнішня система) не повернув ідентифікатор користувача разом з верифікованою адресою електронної пошти.`);

            //alert(`Система не отримала вашу електронну пошту або вона не збігається з поштою, яка раніше використовувалась. Перевірте, чи вказана електронна пошта у Модулі авторизації https://wso2id.kyivcity.gov.ua та чи збігається вона з поштою вашого профілю в Системі. Після цього повторіть вхід. Якщо проблема не зникає — зверніться до технічної підтримки.`);

            isFinishInitToken = true;

            return tokenData.error;
          }

          if(tokenData.error){
            //alert('Виникла помилка під час авторизації');

            isFinishInitToken = true;

            return tokenData.error;
          }
          
          if (tokenData.data && tokenData.data.token) {

            const user_info = {
              user: tokenData.data.user,
              privilegedUser: tokenData.data.privilegedUser,
              auth_type: tokenData.data.auth_type,
              expDate: tokenData.data.expDate
            }

            setAuthToken(tokenData.data.token);
            setUserInfo(user_info);

            isFinishInitToken = true;
            
            return tokenData.data;
           
          }
        } catch (error) {
          console.error('Token exchange error:', error);

          isFinishInitToken = true;

          return error;
        }
      }

      isFinishInitToken = true;
}

export const getAuthToken = () => {
  return access_token || localStorage.getItem(PERSISTENTS_STORAGE.token);
};

const apiClient = {
  async request(url, options = {}) {
    const token = getAuthToken();
    
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    if (token) {
      headers['token'] = `${token}`;
    }

    const response = await fetch(constr_uri(url), {
      ...options,
      headers,
    });

    if(response.status == 401) handleLogin();

    if (!response.ok) {
      // Намагаємось прочитати тіло відповіді — бекенд зазвичай віддає
      // { error: { code, message, details } } навіть для не-2xx статусів
      // (responseHandler.error за замовчуванням віддає HTTP 500).
      // Раніше тут кидався generic Error без тіла відповіді, і фронт ніде
      // не міг прочитати код/повідомлення/деталі помилки для таких відповідей
      // — лише текст "HTTP error! status: 500".
      let body;
      try {
        body = await response.json();
      } catch (parseError) {
        body = undefined;
      }

      const backendError = body && body.error;
      const error = new Error(
        (backendError && backendError.message) || `HTTP error! status: ${response.status}`
      );
      error.status = response.status;
      if (backendError) {
        error.code = backendError.code;
        error.details = backendError.details;
      }
      error.response = body;

      throw error;
    }

    return response.json();
  },

  get(url) {
    return this.request(url);
  },

  post(url, data) {
    return this.request(url, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  put(url, data) {
    return this.request(url, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  patch(url, data) {
    return this.request(url, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  },

  delete(url, data) {

    const obj_d = {
      method: 'DELETE',
    };

    if(data) obj_d['body'] = JSON.stringify(data);

    return this.request(url, obj_d);
  },
};

export const apiSendFileHeader = async (url, file, desc)=>{

  const finfHeader = Buffer.from(JSON.stringify(desc)).toString('base64');

  const token = getAuthToken();

  const headers = {
      'Content-Type': 'application/octet-stream',
      'finf': finfHeader
  };

    if (token) {
      headers['token'] = `${token}`;
    }
  

  try{

    const response = await fetch(constr_uri(url),{
      method: 'PUT',
      headers,
      body: file
    })

    return response
  } catch(err){

    return ({ error: err})
  }
  
  
}

export const downloadFile = async (url, fileName=null, typeReq='get')=>{

  const token = getAuthToken();

  const headers = token ? { token } : {};

  const options = { headers };

  if(typeReq !== 'get'){
    options['method'] = 'post';

    options['headers']['Content-type'] = 'application/json';

    options['body'] = JSON.stringify({ name_instruction: fileName })
  }

  const response = await fetch(constr_uri(url), options);

  const contentType = response.headers.get("content-type");
  const contentDisposition = response.headers.get("content-disposition");

  const name_from_server = contentDisposition?.split("filename=") && decodeURI(contentDisposition?.split("filename=")[1]) || null;


  if (response.ok) {
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download =  fileName || name_from_server || 'file' ;
    link.click();
    window.URL.revokeObjectURL(url);
  }
  
  return response;
}


export const loadFileAsBase64 = async (url,  mime) => {


  const token = getAuthToken();
  const headers = { token };

  try {
    const response = await fetch(constr_uri(url), { headers });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = () => {
        reject(new Error('Failed to convert blob to Base64'));
      };
      reader.readAsDataURL( mime ? blob.slice(0, blob.size, mime) : blob);
    });
  } catch (error) {
    console.error('Error loading file:', error);
    throw error;
  }
};

export const loadFileAsBlob = async (url) => {


  const token = getAuthToken();
  const headers = { token };

  try {
    const response = await fetch(constr_uri(url), { headers });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    
   return blob;

   
  } catch (error) {
    console.error('Error loading file:', error);
    throw error;
  }
};


export const checkRegistartionChildrenReq = async (input,id)=>{

        try{
                let DataToServ = { 
                    "fName": input.fName.trim(),
                    "birthDate": input.birthDate,
                    "birthCert": input.birthCert,
                    "lName": input.lName.trim()
                };

                if (DataToServ.birthDate.split('T').length === 2){
                    DataToServ.birthDate = DataToServ.birthDate.split('T')[0]
                }

                const url = 'checkMR/'+id;

                const result = await apiClient.post(url, DataToServ);


                if(result.data.status == "ok") return alert('Інформація підтверджена, дитина зареєстрована в м. Київ');
                alert('Не знайдено такого свідоцтва в реєстрі територіальної громади.');

                return;
        } catch(err){
              return alert('Виникла помилка під час перевірки реєстрації дитини в м. Київ');
        }

}

export default apiClient;